import React from 'react';
import _ from 'lodash';
// import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';

import { Table, Column, HeaderCell, Cell, ColumnGroup} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';
import { alphaNumericSort } from '../../util/sorting';

const baseTableProps = {
    height: 720,
};

const baseStyles = {
    zIndex: 0,
}






export const SubmissionGrid = ({dataSource, onRowClick}) => {
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string') {
          x = x.charCodeAt();
        }
        if (typeof y === 'string') {
          y = y.charCodeAt();
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

const checkArtistSearchStatus = (key, artist) => {
    switch (key) {
        case 'hasEnoughSongs':
            return (artist.songs?.length || 0) > 0;
        case 'hasBio':
            return _.isString(artist.bio) && artist.bio.trim().length > 0;
        case 'hasBannerImage':
            return _.isString(artist.bannerImage) && artist.bannerImage.trim().length > 0;
        case 'hasProfileImage':
            return _.isString(user?.profileImage) && user.profileImage.trim().length > 0;
    }
}

//TODO: Actually handle sorting column
const handleSortColumn = (sortColumn, sortType) => {
    // console.log(sortColumn, sortType);
    // alphaNumericSort(sortColumn, sortType);
    // setLoading(true);
};

    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick} 
        sortType={sortType}
        onSortColumn={(sortColumn, sortType) => {
            console.log(sortColumn, sortType);
            handleSortColumn(sortColumn, sortType)
        }}
        loading={loading}
    >
            <Column width={200} fixed sortable resizable>
                <HeaderCell>Artist Name</HeaderCell>
                <Cell>{rowData => rowData.name}</Cell>
            </Column>
            <Column width={200} fixed sortable resizable>
                <HeaderCell>Email Address</HeaderCell>
                <Cell>{rowData => rowData.email}</Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell>Genre</HeaderCell>
                <Cell>{rowData => rowData.genre}</Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell>Join Date</HeaderCell>
                <Cell>{rowData => new Date(rowData.createdAt).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                    })}
                </Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell># Submissions</HeaderCell>
                <Cell>{rowData => rowData.catalogSize}</Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell>Status</HeaderCell>
                <Cell>{rowData => rowData.status}</Cell>
            </Column>
            {/* <ColumnGroup header="Artist Onboarding" groupHeaderHeight={100} align='center'> */}
                <Column align='center' width={120} colSpan={2}>
                    <HeaderCell>Profile Picture</HeaderCell>
                    <Cell>{rowData => rowData.searchStatus?.hasProfileImage && (<span className='status-bubble ok' />)}</Cell>
                </Column>
                <Column align='center' width={120} colSpan={2}>
                    <HeaderCell>Banner Picture</HeaderCell>
                    <Cell>{rowData => rowData.searchStatus?.hasBannerImage && (<span className='status-bubble ok' />)}</Cell>
                </Column>
                <Column align='center' width={120} colSpan={2}>
                    <HeaderCell>Bio</HeaderCell>
                    <Cell>{rowData => rowData.searchStatus.hasBio && (<span className='status-bubble ok' />)}</Cell>
                </Column>
                <Column align='center' width={120} colSpan={2}>
                    <HeaderCell>Tracks Loaded</HeaderCell>
                    <Cell>{rowData => rowData.searchStatus.hasEnoughSongs && (<span className='status-bubble ok' />)}</Cell>
                </Column>
                <Column align='center' width={120} colSpan={2}>
                    <HeaderCell>Stripe Setup</HeaderCell>
                    <Cell>{rowData => rowData.searchStatus.hasStripeSetup && (<span className='status-bubble ok' />)}</Cell>
                </Column>
            {/* </ColumnGroup> */}
            {/* <Column width={250} fixed sortable resizable>
                <HeaderCell>Lifetime Submissions</HeaderCell>
                <Cell>{rowData => rowData.lifetimeSubmissions}</Cell>
            </Column> */}
     </Table>
    );
}
